import React, { useEffect, useState } from 'react';
import { formatToZMW, rootUrl } from '../../../helpers';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { useAuth } from '../../../context/auth-context';
import { toast } from 'react-toastify';
import FormGenerator from '../../../components/formGenerator';
import { FaFolderOpen } from 'react-icons/fa';

export default function SupplierStatement({ id, name }){
    const [data, setData] = useState([]); 
    const [balance, setBalance] = useState(0.0); 
    const [loading, setLoading] = useState(false); 
    const [error, setError] = useState(null); 
    const [makePayment, setMakePayment] = useState(false);
    const [projects, setProjects] = useState([]);

    useEffect(()=>{
        fetchData()
        axios.get(rootUrl(`/getProjs`))
        .then(response => {  
          setProjects(response.data.data); 
        })
        .catch(error => {
            setError('Error fetching data');
            console.error(error);
        })
    }, [])


    const auth = useAuth();
    const allData = useOutletContext();


    const fetchData = () => {
        setLoading(true); 
        setError(null); 
        axios.get(rootUrl(`/suppliertrans/${id}`))
            .then(response => {  
                setData(response.data.data); 
            })
            .catch(error => {
                setError('Error fetching data');
                console.error(error);
            })
            .finally(() => setLoading(false)); // Stop loading
    };



    const [fields, setFields] = useState([]);

         useEffect(() => {

            if (projects) {
              setFields([
                {type: 'select', name: 'coa', label: 'Chart Of Account', dependentFields: ['project'], required: true, options:
                    data.filter(a=>a.type == 1).map((res)=>({
                    value:res.coa,
                    label:`${allData.budget?.find(a=>a.id === res.coa)?.coa}`
                  }))
                },
                {type: 'select', name: 'project', label: 'Project', options:
                  projects.map((res)=>({
                  value:res.id,
                  label:res.name,
                  dependsOn: 'coa',
                  dependentValue: res.b_id,
                }))
              },
                {type: 'select', name: 'sof', label: 'Source of fund', required: true, 
                    options:allData.sof.map((res)=>({
                        value:res.id,
                        label:res.name
                      }))},
                {type: 'select', name: 'type', label: 'Type', required: true, options:[
                    {value:1, label:'Payment'},
                    {value:2, label:'Credit note'},
                  ]},
                {type: 'text', name: 'amount', label: 'Amount', required: true},
                {type: 'text', name: 'description', label: 'Description', required: true},
              ]
        );
            }
          }, [allData, projects]);
          
          
    

    
    
      const onsubmit = async (formdata)=>{      
        formdata['uid'] = auth.user.id
        formdata['sid'] = id
        try{
          const response = await axios.post(rootUrl('/addSupPayment'), formdata)
          if(response.data.status === 200){
            toast.success("Submitted successfully")
            setMakePayment(false)
          }else{
            toast.error("Something went wrong")
          }
      
      
        }catch(e){
          toast.error(e?.message)
        }
      
      }
      

    return (
        <div>
          
            {loading && <p>Loading...</p>} {/* Loading indicator */}
            {error && <p className="text-red-500">{error}</p>} {/* Error message */}
            
            {data.length === 0 ? (
                <div className="flex flex-col justify-center items-center">
                                                  <FaFolderOpen className="text-gray-500 text-6xl mb-2" />
                                                  <p className="text-gray-600">No data available</p>
                                                </div>
            ) : (
                <>
                    
                        <p className="text-lg font-semibold text-gray-600 p-2 m-2">{name}</p>
                    
                    <table className="min-w-full border border-gray-300 p-2 m-2">
    <thead>
        <tr className="text-left bg-blue-900 text-white">
            <th className="border-b px-4 py-2">Date</th>
            <th className="border-b px-4 py-2">Invoice #</th>
            <th className="border-b px-4 py-2">Description</th>
            <th className="border-b px-4 py-2">Debit</th>
            <th className="border-b px-4 py-2">Credit</th>
            <th className="border-b px-4 py-2">Balance</th>
        </tr>
    </thead>
    <tbody>
        {(() => {
            let runningBalance = 0; // Initialize the running balance
            return data.map((res, index) => {
                // Calculate debit and credit
                const debit = res.type == 1 ? res.amount : 0;
                const credit = res.type == 2 ? res.amount : 0;

                // Update running balance
                runningBalance += debit - credit;

                return (
                    <tr key={index}>
                        <td className="border-b px-4 py-2">{res.date.substring(0, 10)}</td>
                        <td className="border-b px-4 py-2">
                            {res.invoice != null ? res?.invoice : res?.receipt_no}
                        </td>
                        <td className="border-b px-4 py-2">{res.comment}</td>
                        <td className="border-b px-4 py-2">{formatToZMW(debit)}</td>
                        <td className="border-b px-4 py-2">{formatToZMW(credit)}</td>
                        <td className="border-b px-4 py-2">{formatToZMW(runningBalance)}</td>
                    </tr>
                );
            });
        })()}
    </tbody>
</table>

                </>
            )}

<button className="border rounded p-2 my-2 bg-blue-900 text-white m-4" onClick={()=>setMakePayment(!makePayment)}>Add Payment</button>
<br/>
  {
            makePayment?
            <><span className="font-bold text-lg m-4">Make Payment</span>
            <hr className="mb-3" />
            <div className='m-2 p-2'>
            <FormGenerator fields={fields} onSubmit={onsubmit} />
            </div>
               </>
            :
            <></>
          }

        </div>
    );
};
